/* ac-pack-picker.js - the pack cards drive Dawn's own variant picker.
 *
 * THE BUG THIS WAS REWRITTEN FOR (Carl, 2026-09-02, reproduced exactly as he described):
 *   add the 10 pack, then select the 5 pack and add again, and the 10 pack goes in a second time.
 * The card highlighted, so the click handler was running, but Dawn's radio never changed and the
 * form's hidden variant id stayed on the 10 pack. Selecting a pack and getting a different one
 * in the cart is the worst class of bug on a shop, so this file no longer assumes anything
 * worked. It re-reads the DOM every time, and it verifies.
 *
 * Three changes:
 *   1. `variant-selects` is looked up on every interaction, never captured once. A reference
 *      taken at page load can be replaced by Dawn re-rendering the picker, and writing to a
 *      detached node fails silently, which is exactly how this hid.
 *   2. The label is clicked, which is what a person does, so Dawn runs its own handlers rather
 *      than depending on a synthetic change event reaching the right listener.
 *   3. It CHECKS. After selecting, the form's hidden id is compared with the variant the card
 *      asked for, and it retries once. And at submit time, if they still disagree, the form is
 *      corrected before it posts.
 *
 * (3) is the part that matters. Whatever Dawn does internally, the variant that goes into the
 * cart is the one whose card is selected on screen.
 */
(function () {
  'use strict';

  var wrap = document.querySelector('[data-ac-packs]');
  if (!wrap) return;

  function picker() {
    return document.querySelector('variant-selects');
  }

  function form() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function idInput() {
    var f = form();
    return f ? f.querySelector('input[name="id"]') : null;
  }

  if (!picker()) return;           // no picker to drive, leave the page alone
  document.body.classList.add('ac-has-packs');

  function cardFor(id) {
    return wrap.querySelector('[data-ac-pack="' + id + '"]');
  }

  function selectedCard() {
    return wrap.querySelector('[data-ac-pack].is-sel');
  }

  function paint(id) {
    var cards = wrap.querySelectorAll('[data-ac-pack]');
    for (var i = 0; i < cards.length; i++) {
      var on = cards[i].getAttribute('data-ac-pack') === String(id);
      cards[i].classList.toggle('is-sel', on);
      cards[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  // Ask Dawn to select this variant, the way a person would.
  function choose(title) {
    var p = picker();
    if (!p) return false;

    var radios = p.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value !== title) continue;
      var label = radios[i].id ? p.querySelector('label[for="' + CSS.escape(radios[i].id) + '"]') : null;
      if (label) {
        label.click();
      } else {
        radios[i].checked = true;
        radios[i].dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    }

    var sel = p.querySelector('select');
    if (sel) {
      sel.value = title;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  }

  // The variant the shopper last asked for. While this is set, the repaint below leaves the
  // cards alone: Dawn re-renders asynchronously, so reading the form id straight after a click
  // gives the PREVIOUS variant and repaints the wrong card. That is what made the highlight lag
  // one click behind, even though the variant going to the cart was already correct.
  var pendingId = null;

  wrap.addEventListener('click', function (e) {
    var card = e.target.closest ? e.target.closest('[data-ac-pack]') : null;
    if (!card || card.disabled) return;

    var wantId = card.getAttribute('data-ac-pack');
    var title = card.getAttribute('data-variant-title');

    pendingId = wantId;
    paint(wantId);                 // the card responds immediately
    choose(title);

    // Then confirm Dawn actually moved, and try once more if it did not. Dawn re-renders the
    // picker asynchronously, so this waits a beat rather than reading straight away.
    setTimeout(function () {
      var input = idInput();
      if (input && String(input.value) !== String(wantId)) {
        choose(title);
        setTimeout(function () {
          var again = idInput();
          if (again && String(again.value) !== String(wantId)) {
            // Last resort: set it on the form directly. The cart is what matters, and the card
            // on screen is what the shopper chose.
            again.value = wantId;
          }
          if (pendingId === wantId) pendingId = null;
        }, 250);
      } else if (pendingId === wantId) {
        pendingId = null;
      }
    }, 250);
  });

  // Keep the cards in step when the variant changes from anywhere else.
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest || !e.target.closest('variant-selects')) return;
    setTimeout(function () {
      // A selection made from the cards is already painted and is still settling. Only follow
      // the form when the change came from somewhere else.
      if (pendingId !== null) return;
      var input = idInput();
      if (input && cardFor(input.value)) paint(input.value);
    }, 60);
  });

  // THE GUARANTEE. Whatever happened above, the variant posted is the one whose card is selected.
  // Capture phase, so this runs before Dawn's own submit handling.
  function enforce() {
    var card = selectedCard();
    var input = idInput();
    if (!card || !input) return;
    var wantId = card.getAttribute('data-ac-pack');
    if (String(input.value) !== String(wantId)) {
      input.value = wantId;
      try {
        document.dispatchEvent(new CustomEvent('ac_pack_mismatch_corrected', {
          detail: { was: input.value, now: wantId }
        }));
      } catch (err) { /* reporting only */ }
    }
  }

  var f = form();
  if (f) {
    f.addEventListener('submit', enforce, true);
    var add = f.querySelector('button[name="add"], [type="submit"]');
    if (add) add.addEventListener('click', enforce, true);
  }
})();
